module.exports = __webpack_public_path__ + "img/16.1f247e87.png";